const DollarIcon = ({ stroke, ...props }) => (
  <svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M32.1178 59.1908C46.8454 59.1908 58.7845 47.2517 58.7845 32.5241C58.7845 17.7965 46.8454 5.85742 32.1178 5.85742C17.3902 5.85742 5.45117 17.7965 5.45117 32.5241C5.45117 47.2517 17.3902 59.1908 32.1178 59.1908Z"
      stroke="#2E3860"
      strokeWidth="4"
    />
    <path d="M32.1182 16.5234V48.5234" stroke="#2E3860" strokeWidth="4" strokeLinecap="round" />
    <path
      d="M40.1182 25.8561C40.1182 22.1742 36.5366 19.1895 32.1182 19.1895C27.6998 19.1895 24.1182 22.1742 24.1182 25.8561C24.1182 29.538 27.6998 32.5228 32.1182 32.5228C36.5366 32.5228 40.1182 35.5076 40.1182 39.1895C40.1182 42.8713 36.5366 45.8561 32.1182 45.8561C27.6998 45.8561 24.1182 42.8713 24.1182 39.1895"
      stroke="#2E3860"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export default DollarIcon;
